import createAccordion from "../../common/initAccordions.js";

export default () => {
  if (document.querySelector(".is-page-editor")) {
    return;
  }

  const isSelectedClass = "is-selected";

  document.querySelectorAll(".js-tabbed-content").forEach((el, appIndex) => {
    // find the tablist element
    const elTabList = el.querySelector(".js-tabbed-content-controls");
    const elPanels = el.querySelectorAll(".js-tabbed-content-panel");
    const elTabs = el.querySelectorAll(".js-tabbed-content-tab");
    const elNextButton = el.querySelector(".js-tabbed-content__next-button");
    const elPrevButton = el.querySelector(
      ".js-tabbed-content__previous-button",
    );
    const elAccordionLinks = el.querySelectorAll(".js-accordion-link");
    const accordion =
      el.dataset.accordion === "true" || el.dataset.accordion === "True"; // Sitecore using True for boolen.
    const parentIndex = appIndex + 1 * 100;
    const tabButtonSelector = ".js-tabbed-content-tab-button";
    const breakpoint = 780;

    let isMobile = window.innerWidth <= breakpoint;
    let currentTab = 0;
    let isOverflowing;

    // initialize tabs and panels
    elTabs.forEach(initTab);
    elPanels.forEach(initPanel);

    showThisTab(currentTab, false);

    elTabList.addEventListener("keydown", handleKeyPress);

    elAccordionLinks.forEach((el, i) => {
      el.addEventListener("click", () => {
        if (currentTab !== i) {
          changeTab(i);
        }
      });
    });

    // initialize accordion or overflow interface
    accordion ? initAccordion() : initOverflow();

    function changeTab(newTab, moveFocus = true) {
      if (newTab === currentTab) {
        return;
      }

      hideCurrentTab(currentTab, moveFocus);
      showThisTab(newTab, moveFocus);

      if (!accordion) {
        if (newTab === 0) {
          elPrevButton.setAttribute("disabled", true);
        } else if (newTab === elTabs.length - 1) {
          elNextButton.setAttribute("disabled", true);
        } else {
          elPrevButton.removeAttribute("disabled");
          elNextButton.removeAttribute("disabled");
        }

        elTabList.scrollTo({
          top: 0,
          left: elTabs[newTab].offsetLeft - 30, // not sure why this is 3
          behavior: "smooth",
        });
      }
    }

    function hideCurrentTab(tabIndex) {
      // reset currently selected Tab aria-selected and classes
      const activeTab = elTabs[tabIndex];
      activeTab.classList.remove(isSelectedClass);

      const activeTabButton = activeTab.querySelector(tabButtonSelector);
      activeTabButton.setAttribute("aria-selected", false);
      activeTabButton.setAttribute("tabindex", -1);
      // reset currently selected Panel classes
      const panel = elPanels[tabIndex];
      panel.classList.remove(isSelectedClass);
      panel.setAttribute("aria-hidden", true);
      panel.setAttribute("tabindex", -1);
    }

    function showThisTab(tabIndex, moveFocus = true) {
      // set this Tab's aria-selected and classes
      elTabs[tabIndex].classList.add(isSelectedClass);
      const button = elTabs[tabIndex].querySelector(tabButtonSelector);
      button.setAttribute("aria-selected", true);
      button.setAttribute("tabindex", 0);

      if (moveFocus) {
        button.focus();
      }
      // set this Tab's panel class
      const panel = elPanels[tabIndex];
      panel.classList.add(isSelectedClass);
      panel.removeAttribute("aria-hidden");
      panel.setAttribute("tabindex", 0);

      currentTab = tabIndex;
    }

    function handleKeyPress(event, index) {
      switch (event.key) {
        case "Left":
        case "ArrowLeft":
          event.preventDefault();
          if (currentTab === 0) {
            changeTab(elTabs.length - 1);
          } else {
            changeTab(currentTab - 1);
          }
          break;
        case "Right":
        case "ArrowRight":
          event.preventDefault();
          if (currentTab === elTabs.length - 1) {
            changeTab(0);
          } else {
            changeTab(currentTab + 1);
          }
          break;
        default:
      }
    }

    function handleAccordionResize(e) {
      if (isMobile && window.innerWidth > breakpoint) {
        elPanels.forEach((panel, i) => {
          if (i !== currentTab) {
            panel.setAttribute("aria-hidden", true);
            panel.setAttribute("tabindex", -1);
          } else {
            panel.setAttribute("tabindex", 0);
          }
        });
        isMobile = false;
      }

      if (!isMobile && window.innerWidth <= breakpoint) {
        elPanels.forEach((panel) => {
          panel.removeAttribute("aria-hidden");
          panel.removeAttribute("tabindex");
        });
        isMobile = true;
      }
    }

    function handleOverflowResize(e) {
      const overflowing = elTabList.scrollWidth !== elTabList.clientWidth;

      if (isOverflowing && !overflowing) {
        isOverflowing = false;
        elNextButton.classList.remove(
          "tabbed-content__control-button--visible",
        );
        elPrevButton.classList.remove(
          "tabbed-content__control-button--visible",
        );
      }

      if (!isOverflowing && overflowing) {
        isOverflowing = true;
        elNextButton.classList.add("tabbed-content__control-button--visible");
        elPrevButton.classList.add("tabbed-content__control-button--visible");
      }
    }

    function initPanel(panel, i) {
      // add ids and aria roles to panel
      panel.setAttribute("aria-labelledby", `tab-button-${parentIndex + i}`);
      panel.setAttribute("id", `tab-content-panel-${parentIndex + i}`);
      panel.setAttribute("tabindex", -1);
      panel.setAttribute("aria-hidden", true);
    }

    function initTab(tab, i) {
      // add ids and aria roles to button
      const button = tab.querySelector(tabButtonSelector);
      button.setAttribute("id", `tab-button-${parentIndex + i}`);
      button.setAttribute("aria-selected", false);
      button.setAttribute("tabindex", -1);
      button.setAttribute(
        "aria-controls",
        `tab-content-panel-${parentIndex + i}`,
      );
      // move all the tab to the tablist element
      elTabList.append(tab);

      // add event listeners to tab
      button.addEventListener("click", () => {
        if (currentTab !== i) {
          changeTab(i);
        }
      });
    }

    function initOverflow() {
      el.classList.add("tabbed-content--overflow");

      elPrevButton.setAttribute("disabled", true);

      // event listeners - button click and tab focus
      elNextButton.addEventListener("click", () => {
        changeTab(currentTab + 1, false);
      });

      elPrevButton.addEventListener("click", () => {
        changeTab(currentTab - 1, false);
      });
      // reversing isOverflowing so classes will be set correctly.
      isOverflowing = elTabList.scrollWidth === elTabList.clientWidth;
      handleOverflowResize();

      // add resize event to detect overflow - toggle class
      window.addEventListener("resize", handleOverflowResize, {
        passive: true,
      });
    }

    function initAccordion() {
      window.addEventListener("resize", handleAccordionResize, {
        passive: true,
      });
      el.classList.add("tabbed-content--accordion");
      el.querySelectorAll(".js-tabbed-content-accordion").forEach((el, i) => {
        createAccordion(el, parentIndex + i, breakpoint);
      });
    }
  });
};
